import classNames from 'classnames';
import React from 'react';

import { circle } from './ui.style';

const MediaType = ({ icon, legend, onClick, disabled, 'data-cy': dataCy }) => (
  <div className="d-flex flex-column align-items-center" onClick={onClick} data-cy={dataCy}>
    <div
      className={classNames(
        circle,
        { disabled },
        'rounded-circle bg-white mb-2 d-flex align-items-center justify-content-center text-primary'
      )}
    >
      {icon}
    </div>
    <span className="font-italic text-secondary text-xxs">{legend}</span>
  </div>
);

export default MediaType;
